export const customerListSelector = state => state.customerReducer.customerList;

export const loadingCustomersSelector = state => state.customerReducer.loadingCustomers;
